import React, { useState } from 'react';

import { Button, Grid, Input, makeStyles, Paper, Theme, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
    title: {
        fontSize: '2.0rem',
        color: '#707070',
        paddingTop: theme.spacing(2),
        fontWeight: 'bold'
    },
    input: {
        display: 'inline',
        padding: theme.spacing(2),
    },
    button: {
        height: '100%',
    },
}));

const Search: React.FunctionComponent<PropShape> = props => {
    const classes = useStyles();
    const [searchInput, setSearchInput] = useState(props.initialSearch || '');

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        props.onSearch(searchInput);
    };

    const handleEnterPressed = (e: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>): void => {
        if (e.key === 'Enter') {
            props.onSearch(searchInput);
        }
    };

    return (
        <form role="form" onSubmit={handleFormSubmit}>
            <Grid container direction="column" spacing={2}>
                <Grid item>
                    <Typography variant="h2" component="h2" className={classes.title}>
                        FIND A PROVIDER
                    </Typography>
                </Grid>
                <Grid item>
                    <Grid container spacing={1}>
                        <Grid item sm={8}>
                            <Paper>
                                <Input
                                    id="address"
                                    title="address"
                                    fullWidth
                                    disabled={props.isLoading}
                                    value={searchInput}
                                    inputProps={{ 'aria-label': 'Address' }}
                                    classes={{ input: classes.input }}
                                    onKeyDown={e => handleEnterPressed(e)}
                                    onChange={e => setSearchInput(e.target.value)}
                                />
                            </Paper>
                            {/* <Paper>

                                <TextField
                                    id="address"
                                    title="address"
                                    name="address"
                                    label="FIND A PROVIDER"
                                    fullWidth
                                    disabled={props.isLoading}
                                    value={searchInput}
                                    //classes={{ root: classes.input }}
                                    InputLabelProps={{ shrink: true }}
                                    onKeyDown={e => handleEnterPressed(e)}
                                    onChange={e => setSearchInput(e.target.value)}
                                />
                            </Paper> */}
                        </Grid>
                        <Grid item sm={4}>
                            <Button
                                id="search"
                                title="Search"
                                fullWidth
                                type="submit"
                                color="primary"
                                variant="contained"
                                disabled={props.isLoading}
                                className={classes.button}
                            >
                                Search
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
};

interface PropShape {
    isLoading: boolean;
    onSearch: (searchQuery: string) => void;
    initialSearch: string;
}

Search.defaultProps = {
    // Set default values for props
    isLoading: false,
    onSearch: () => {},
};

export default Search;
